import {
  activeCommentAtom,
  CommentResponse,
  commentsAtom,
} from "@app/shared/atoms/comments-atom";
import { URLS } from "@core/shared/utils";
import { useCallback, useState } from "react";

export const useCommentPagination = (typeId: number, type: string) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const loadMoreComments = useCallback(async () => {
    const currentData = commentsAtom.value;

    const currentPage = currentData.paginationInfo?.page || 1;

    const totalPages = currentData.paginationInfo?.pages || 1;

    if (currentPage >= totalPages || isLoadingMore) return;

    setIsLoadingMore(true);

    const nextPage = currentPage + 1;

    const response = await fetch(
      `${URLS.comments.root}?type=${type}&typeId=${typeId}&page=${nextPage}`,
    );

    if (response.ok) {
      const newData: CommentResponse = await response.json();

      commentsAtom.update({
        ...newData,
        comments: [...currentData.comments, ...newData.comments],
        state: "loaded",
      });

      activeCommentAtom.reset();
    }

    setIsLoadingMore(false);
  }, [typeId, type, isLoadingMore]);

  const hasNextPage = Boolean(
    commentsAtom.value.paginationInfo &&
      commentsAtom.value.paginationInfo.page <
        commentsAtom.value.paginationInfo.pages,
  );

  return {
    loadMoreComments,
    hasNextPage,
    isLoadingMore,
    currentPage: commentsAtom.value.paginationInfo?.page || 1,
    totalPages: commentsAtom.value.paginationInfo?.pages || 1,
  };
};
